export const periodData = [
  { key: 1, name: "Today" },
  { key: 2, name: "Yesterday" },
  { key: 3, name: "This Week" },
  { key: 4, name: "This Month" },
  { key: 5, name: "Last Month" },
  { key: 6, name: "This Year" },
  { key: 7, name: "Custom" }
]

export const months = {
  "01": { key: '01', name: "មករា", en_name: 'January' },
  "02": { key: '02', name: "កុម្ភៈ", en_name: 'February' },
  "03": { key: '03', name: "មីនា", en_name: 'March' },
  "04": { key: '04', name: "មេសា", en_name: 'April' },
  "05": { key: '05', name: "ឧសភា", en_name: 'May' },
  "06": { key: '06', name: "មិថុនា", en_name: 'June' },
  "07": { key: '07', name: "កក្កដា", en_name: 'July' },
  "08": { key: '08', name: "សីហា", en_name: 'August' },
  "09": { key: '09', name: "កញ្ញា", en_name: 'September' },
  "10": { key: '10', name: "តុលា", en_name: 'October' },
  "11": { key: '11', name: "វិច្ឆិកា", en_name: 'November' },
  "12": { key: '12', name: "ធ្នូ", en_name: 'December' },
}

export const monthOfYear = [
  { key: '01', name: "មករា", en_name: 'January' },
  { key: '02', name: "កុម្ភៈ", en_name: 'February' },
  { key: '03', name: "មីនា", en_name: 'March' },
  { key: '04', name: "មេសា", en_name: 'April' },
  { key: '05', name: "ឧសភា", en_name: 'May' },
  { key: '06', name: "មិថុនា", en_name: 'June' },
  { key: '07', name: "កក្កដា", en_name: 'July' },
  { key: '08', name: "សីហា", en_name: 'August' },
  { key: '09', name: "កញ្ញា", en_name: 'September' },
  { key: '10', name: "តុលា", en_name: 'October' },
  { key: '11', name: "វិច្ឆិកា", en_name: 'November' },
  { key: '12', name: "ធ្នូ", en_name: 'December' },
]

export const days = [
  { key: "01", name: "1" },
  { key: "02", name: "2" },
  { key: "03", name: "3" },
  { key: "04", name: "4" },
  { key: "05", name: "5" },
  { key: "06", name: "6" },
  { key: "07", name: "7" },
  { key: "08", name: "8" },
  { key: "09", name: "9" },
  { key: "10", name: "10" },
  { key: "11", name: "11" },
  { key: "12", name: "12" },
  { key: "13", name: "13" },
  { key: "14", name: "14" },
  { key: "15", name: "15" },
  { key: "16", name: "16" },
  { key: "17", name: "17" },
  { key: "18", name: "18" },
  { key: "19", name: "19" },
  { key: "20", name: "20" },
  { key: "21", name: "21" },
  { key: "22", name: "22" },
  { key: "23", name: "23" },
  { key: "24", name: "24" },
  { key: "25", name: "25" },
  { key: "26", name: "26" },
  { key: "27", name: "27" },
  { key: "28", name: "28" },
  { key: "29", name: "29" },
  { key: "30", name: "30" },
  { key: "31", name: "31" },
]
